import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeSimu1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3, handleClickSel4}) => {
  const a3001 = autorizacUA.findIndex( autorizac => autorizac === "3001" );
  const a3005 = autorizacUA.findIndex( autorizac => autorizac === "3005" );
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="share alternate yellow icon"></i>
        SIMULADORES
      </button>

      {a3001!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
          <i className="large stop circle outline red icon"></i>
          Rótulos de lubricación
        </button>
      }      
      {a3005!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
          <i className="large warning sign red icon"></i>
          Valores de alarma y peligro para pruebas de laboratorio de aceites
        </button>
      }   
      {a3005!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
          <i className="large random red icon"></i>
          Valores de viscosidad
        </button>
      }      
      {a3005!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
          <i className="large recycle red icon"></i>
          Flushing Hidráulico
        </button>
      }      
    </div>
  )
};

export default HomeSimu1
